const FACTORING_MIN_VERSION = 3.2;
const CONFIRMING_MIN_VERSION = 1.2;
const NEW_CONTRACT_POPUP_CUTOFF = new Date('2026-10-19T05:00:00.000Z');

export function isContractVersionAtLeast(version: string, minVersion: number): boolean {
  return Number(version) >= minVersion ;
}

export function usesCostoSinIgvPlusOne(operation?: any): boolean {
  return operation?.calculationRuleVersion === 1 || operation?.calculationRuleVersion === 3;
}

export function shouldShowNewContractPopup(profile: any): boolean {
  if (!profile || profile.role !== 'client') {
    return false;
  }

  if (profile.showNewContract === false) {
    return false;
  }

  if (!profile.createdAt || (new Date(profile.createdAt) >= NEW_CONTRACT_POPUP_CUTOFF)) {
    return false;
  }
  
  const factoringVersion = profile.contracts?.find((contract:any)=> contract.type === 'factoring');
  const confirmingVersion = profile.contracts?.find((contract:any)=> contract.type === 'confirming');

  const hasEligibleFactoring =
    factoringVersion &&
    isContractVersionAtLeast(factoringVersion?.contractVersion, FACTORING_MIN_VERSION);
  const hasEligibleConfirming =
    confirmingVersion &&
    isContractVersionAtLeast(confirmingVersion?.contractVersion, CONFIRMING_MIN_VERSION);

  return !!(hasEligibleFactoring || hasEligibleConfirming);
}
